import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { WizardPage, wizardProps, WizardContext } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { MLScriptComponent } from 'ml-components-common-react';
import metadata from './DisclaimerComponent.metadata.json5';
import messages from './DisclaimerComponent.messages';

const DisclaimerComponent = (props) => {

    const { scriptML, radioSelection , setRadioSelection} = props;

    const overrideProps = {
        ScriptComponent: {
            mlScript: scriptML,
            isActionContainerRequired : true,
            setRadioSelection,
            radioSelection
        }
    };

    const resolvers = {
        resolveCallbackMap: {

        },
        resolveComponentMap: {
            mlScriptComponent: MLScriptComponent
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
        />
    );
};

DisclaimerComponent.propTypes = wizardProps;
export default DisclaimerComponent;
